import { Alert, Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, Grid, IconButton, Radio, RadioGroup, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import { LoadingPage } from "../../../../common/LoadingPage";
import { apiRequest } from "../../../../common/common";
import { Condtions, CurrencyJSON, handleUndefined } from "../../../../common/const";
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const DemoTypo = styled(Typography)(({ theme }) => ({
    fontWeight: 'bold',
    fontSize: 13
}));

const DemoTypography = styled(Typography)(({ theme }) => ({
    color: '#1565c0',
    fontSize: 13
}));

const Cell = styled(TableCell)({
    padding: '5px',
    textAlign: 'center'
});

const AssetManagement = ({
    itemData,
    getInitialData,
    projectData
}) => {
    const [isOpen, setOpen] = useState(false);
    const [anotheOpen, setAnotherOpen] = useState(false);
    const [dataLoading, setDataLoading] = useState(false);
    const [asset, setAsset] = useState({
        serial_no: null,
        bio_med_tag: null,
        asset_tag: null,
        other_tag: null,
        condition: null,
        condition_notes: null
    });
    const [lifetime, setLifetime] = useState({
        acquisiton_date: null,
        useful_life: 0,
        end_of_userful_life_date: null,
        depreciation: null,
        warrenty_start_date: null,
        warrenty_expiration_date: null,
        warrenty_duration: null
    });
    const [lifetimeErrors, setLifetimeErrors] = useState({});
    const [type, setType] = useState(null);

    // Required fields for Costing/Lifetime save
    const validateLifetime = (data) => {
        const errors = {};
        if (!data.acquisiton_date)          errors.acquisiton_date          = 'Acquisition Date is required';
        if (!data.end_of_userful_life_date) errors.end_of_userful_life_date = 'End of Useful Life Date is required';
        if (!data.useful_life)              errors.useful_life              = 'Useful Life is required';
        return errors;
    };
    const lifetimeValid = Object.keys(validateLifetime(lifetime)).length === 0;
    const [itemTotal, setItemTotal] = useState(0);
    const [scrapAmount, setAmount] = useState(0);

    useEffect(() => {
        if (itemData && isOpen) {
            setAsset({
                serial_no: itemData?.serial_no,
                bio_med_tag: itemData?.bio_med_tag,
                asset_tag: itemData?.asset_tag,
                other_tag: itemData?.other_tag,
                condition: itemData?.condition,
                condition_notes: itemData?.condition_notes
            });
        }
        if (itemData && anotheOpen) {
            setLifetime({
                acquisiton_date: moment(itemData?.acquisiton_date).format('YYYY-MM-DD'),
                useful_life: itemData?.useful_life ? itemData?.useful_life : itemData?.life_expectancy ? itemData?.life_expectancy : 0,
                end_of_userful_life_date: itemData?.end_of_userful_life_date ? moment(itemData?.end_of_userful_life_date).format('YYYY-MM-DD') : itemData?.life_expectancy && itemData?.acquisiton_date ? moment(itemData?.acquisiton_date).add(itemData?.life_expectancy, 'years').format('YYYY-MM-DD') : moment(itemData?.end_of_userful_life_date).format('YYYY-MM-DD'),
                depreciation: itemData?.depreciation || '',
                warrenty_start_date: moment(itemData?.warrenty_start_date).format('YYYY-MM-DD'),
                warrenty_expiration_date: moment(itemData?.warrenty_expiration_date).format('YYYY-MM-DD'),
                warrenty_duration: itemData?.warrenty_duration || 0
            });
        }

        if (type !== null) {
            const data = itemData;
            const subTotal = data?.quantity * data?.unit_price;
            const tax = ((data?.quantity * data?.unit_price) * Number((!projectData?.is_tax_exempt ? data?.tax : 0))) / 100;
            let additionalTax = 0;
            const taxableOption = projectData?.taxable_option !== undefined ? JSON.parse(projectData?.taxable_option) : null;
            if (taxableOption?.length > 0) {
                if (taxableOption.includes('Freight')) {
                    additionalTax = additionalTax + ((Number(data?.freight) * projectData?.tax_rate) / 100);
                }
                if (taxableOption.includes('Installation')) {
                    additionalTax = additionalTax + ((Number(data?.installation) * projectData?.tax_rate) / 100);
                }
                if (taxableOption.includes('Storage')) {
                    additionalTax = additionalTax + ((Number(data?.storage) * projectData?.tax_rate) / 100);
                }
                if (taxableOption.includes('Fees')) {
                    additionalTax = additionalTax + ((Number(data?.fees) * projectData?.tax_rate) / 100);
                }
            }
            if (data.salvage_amount && type === 'slm') {
                setAmount(data.salvage_amount);
            } else if (data.scrape_amount && type === 'wdv') {
                setAmount(data.scrape_amount);
            } else {
                setAmount(((subTotal + tax + Number(data?.freight) + Number(data?.installation) + Number(data?.fees) + Number(data?.storage) - Number(data?.discounts) - Number(data?.tradein) + Number(additionalTax)) * 5) / 100)
            }
            setItemTotal(subTotal + tax + Number(data?.freight) + Number(data?.installation) + Number(data?.fees) + Number(data?.storage) - Number(data?.discounts) - Number(data?.tradein) + Number(additionalTax));

        }
    }, [itemData, isOpen, anotheOpen, type]);

    const generateYearRange = (startDate, endDate) => {
        const startYear = new Date(startDate).getFullYear();
        const endYear = new Date(endDate).getFullYear() - 1;
        const years = [];

        for (let year = startYear; year <= endYear; year++) {
            years.push(year);
        }

        return years;
    };

    // ── Derive missing-field lists for each depreciation method ─────────────
    const slmMissingFields = type === 'slm' ? [
        !itemData?.acquisiton_date          && 'Acquisition Date',
        !itemData?.end_of_userful_life_date && 'End of Useful Life Date',
        !itemData?.useful_life              && 'Useful Life (years)',
    ].filter(Boolean) : [];

    const wdvMissingFields = type === 'wdv' ? [
        !itemData?.acquisiton_date          && 'Acquisition Date',
        !itemData?.end_of_userful_life_date && 'End of Useful Life Date',
        !itemData?.useful_life              && 'Useful Life (years)',
        !itemData?.depreciation             && 'Depreciation (%)',
    ].filter(Boolean) : [];

    const slmCanShow = type === 'slm'
        && itemData?.acquisiton_date
        && itemData?.end_of_userful_life_date
        && scrapAmount !== null;

    const wdvCanShow = type === 'wdv'
        && itemData?.useful_life
        && itemData?.acquisiton_date
        && itemData?.end_of_userful_life_date;

    return (
        <>
            <Dialog open={isOpen} fullWidth maxWidth="sm">
                <DialogTitle>Asset</DialogTitle>
                <DialogContent>
                    {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
                    <Grid container spacing={2} mt={0.2}>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Serial No"
                                id="serial no"
                                type="text"
                                fullWidth
                                size="small"
                                value={asset?.serial_no || ''}
                                onChange={(e) => {
                                    setAsset((prevData) => ({
                                        ...prevData,
                                        serial_no: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: asset?.serial_no !== null && asset?.serial_no !== '',
                                }}
                                inputProps={{
                                    style: { padding: '10px' },
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Bio-Med Tag"
                                id="bio_med_tag"
                                type="text"
                                fullWidth
                                size="small"
                                value={asset?.bio_med_tag || ''}
                                onChange={(e) => {
                                    setAsset((prevData) => ({
                                        ...prevData,
                                        bio_med_tag: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: asset?.bio_med_tag !== null && asset?.bio_med_tag !== '',
                                }}
                                inputProps={{
                                    style: { padding: '10px' },
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Asset Tag"
                                id="asset_tag"
                                type="text"
                                fullWidth
                                size="small"
                                value={asset?.asset_tag || ''}
                                onChange={(e) => {
                                    setAsset((prevData) => ({
                                        ...prevData,
                                        asset_tag: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: asset?.asset_tag !== null && asset?.asset_tag !== '',
                                }}
                                inputProps={{
                                    style: { padding: '10px' },
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Other Tag"
                                id="other_tag"
                                type="text"
                                fullWidth
                                size="small"
                                value={asset?.other_tag || ''}
                                onChange={(e) => {
                                    setAsset((prevData) => ({
                                        ...prevData,
                                        other_tag: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: asset?.other_tag !== null && asset?.other_tag !== '',
                                }}
                                inputProps={{
                                    style: { padding: '10px' },
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <Autocomplete
                                value={Condtions.find((c) => c.value === asset?.condition) || null}
                                id="combo-box-demo"
                                size="small"
                                fullWidth
                                options={Condtions}
                                getOptionLabel={(option) => option.name}
                                onChange={(event, newValue) => {
                                    setAsset((prevState) => ({
                                        ...prevState,
                                        condition: newValue?.value || null
                                    }));
                                }}
                                renderInput={(params) => <TextField fullWidth {...params} label="Condition" name="Condition" variant="outlined" />}
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Condition Notes"
                                id="condtion_notes"
                                type="text"
                                fullWidth
                                multiline
                                minRows={3}
                                maxRows={5}
                                size="small"
                                value={asset?.condition_notes || ''}
                                onChange={(e) => {
                                    setAsset((prevData) => ({
                                        ...prevData,
                                        condition_notes: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: asset?.condition_notes !== null && asset?.condition_notes !== '',
                                }}
                                inputProps={{
                                    style: { padding: '10px' },
                                }}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button size="small" variant="contained" color="secondary"
                        onClick={() => {
                            setOpen(false);
                            setAsset({
                                serial_no: null,
                                bio_med_tag: null,
                                asset_tag: null,
                                other_tag: null,
                                condition: null,
                                condition_notes: null
                            });
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={async () => {
                            try {
                                setDataLoading(true);
                                const response = await apiRequest('put', `/project-item/${itemData?.item_id}`, {
                                    ...itemData,
                                    serial_no: asset?.serial_no,
                                    bio_med_tag: asset?.bio_med_tag,
                                    asset_tag: asset?.asset_tag,
                                    other_tag: asset?.other_tag,
                                    condition: asset?.condition,
                                    condition_notes: asset?.condition_notes
                                });
                                if (response.data) {
                                    setOpen(false);
                                    setAsset({
                                        serial_no: null,
                                        bio_med_tag: null,
                                        asset_tag: null,
                                        other_tag: null,
                                        condition: null,
                                        condition_notes: null
                                    });
                                    getInitialData();
                                    setDataLoading(false);
                                    showNotification(response.data.message, 'success');
                                }
                            } catch (error) {
                                setDataLoading(false);
                                showNotification(error?.response?.data.error || error.message, 'error');
                            }
                        }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={anotheOpen} fullWidth maxWidth="sm">
                <DialogTitle>Costing/Lifetime</DialogTitle>
                <DialogContent>
                    {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
                    <Grid container spacing={2} mt={0.2}>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Acquisiton Date"
                                id="acquisiton_date"
                                type="date"
                                fullWidth
                                size="small"
                                required
                                error={Boolean(lifetimeErrors.acquisiton_date)}
                                helperText={lifetimeErrors.acquisiton_date || ''}
                                value={lifetime?.acquisiton_date || ''}
                                onChange={(e) => {
                                    setLifetime((prevData) => ({
                                        ...prevData,
                                        acquisiton_date: e.target.value || null,
                                        useful_life: lifetime?.end_of_userful_life_date ? moment(lifetime?.end_of_userful_life_date)?.diff(moment(e.target.value), 'years') : lifetime?.useful_life
                                    }));
                                    if (e.target.value) setLifetimeErrors((prev) => ({ ...prev, acquisiton_date: undefined }));
                                }}
                                InputLabelProps={{
                                    shrink: lifetime?.acquisiton_date !== null && lifetime?.acquisiton_date !== '',
                                }}
                                inputProps={{
                                    style: { padding: '10px' },
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="End of useful Life Date"
                                id="end_of_userful_life_date"
                                type="date"
                                fullWidth
                                size="small"
                                required
                                error={Boolean(lifetimeErrors.end_of_userful_life_date)}
                                helperText={lifetimeErrors.end_of_userful_life_date || ''}
                                value={lifetime?.end_of_userful_life_date || ''}
                                onChange={(e) => {
                                    setLifetime((prevData) => ({
                                        ...prevData,
                                        end_of_userful_life_date: e.target.value || null,
                                        useful_life: e.target.value ? moment(e.target.value)?.diff(moment(lifetime?.acquisiton_date), 'years') : lifetime?.useful_life
                                    }));
                                    if (e.target.value) setLifetimeErrors((prev) => ({ ...prev, end_of_userful_life_date: undefined }));
                                }}
                                InputLabelProps={{
                                    shrink: lifetime?.end_of_userful_life_date !== null && lifetime?.end_of_userful_life_date !== '',
                                }}
                                inputProps={{
                                    style: { padding: '10px' },
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Useful Life"
                                id="useful_life"
                                type="number"
                                fullWidth
                                size="small"
                                required
                                error={Boolean(lifetimeErrors.useful_life)}
                                helperText={lifetimeErrors.useful_life || ''}
                                value={lifetime?.useful_life || ''}
                                onChange={(e) => {
                                    setLifetime((prevData) => ({
                                        ...prevData,
                                        useful_life: e.target.value || null,
                                        end_of_userful_life_date: moment(lifetime?.acquisiton_date).add(e.target.value, 'years').format('YYYY-MM-DD')
                                    }));
                                    if (e.target.value) setLifetimeErrors((prev) => ({ ...prev, useful_life: undefined }));
                                }}
                                InputLabelProps={{
                                    shrink: asset?.useful_life !== null && asset?.useful_life !== '',
                                }}
                                inputProps={{
                                    style: { padding: '10px' },
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Depreciation"
                                id="depreciation"
                                type="text"
                                fullWidth
                                size="small"
                                value={lifetime?.depreciation || ''}
                                onChange={(e) => {
                                    setLifetime((prevData) => ({
                                        ...prevData,
                                        depreciation: e.target.value || null,
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: asset?.depreciation !== null && asset?.depreciation !== '',
                                }}
                                inputProps={{
                                    style: { padding: '10px' },
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Warrenty Start Date"
                                id="warrenty_star"
                                type="date"
                                fullWidth
                                size="small"
                                value={lifetime?.warrenty_start_date || ''}
                                onChange={(e) => {
                                    setLifetime((prevData) => ({
                                        ...prevData,
                                        warrenty_start_date: e.target.value || null,
                                        warrenty_duration: e.target.value ? moment(lifetime?.warrenty_expiration_date)?.diff(moment(e.target.value), 'years') : lifetime?.warrenty_duration
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: lifetime?.warrenty_start_date !== null && lifetime?.warrenty_start_date !== '',
                                }}
                                inputProps={{
                                    style: { padding: '10px' },
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Warrenty Expiration Date"
                                id="warrenty_expiration_date"
                                type="date"
                                fullWidth
                                size="small"
                                value={lifetime?.warrenty_expiration_date || ''}
                                onChange={(e) => {
                                    setLifetime((prevData) => ({
                                        ...prevData,
                                        warrenty_expiration_date: e.target.value || null,
                                        warrenty_duration: e.target.value ? moment(e.target.value)?.diff(moment(lifetime?.warrenty_start_date), 'years') : lifetime?.warrenty_duration
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: lifetime?.warrenty_expiration_date !== null && lifetime?.warrenty_expiration_date !== '',
                                }}
                                inputProps={{
                                    style: { padding: '10px' },
                                }}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={6}>
                            <TextField
                                label="Warrenty Duration"
                                id="Warrenty Duration"
                                type="number"
                                fullWidth
                                size="small"
                                value={lifetime?.warrenty_duration || ''}
                                onChange={(e) => {
                                    setLifetime((prevData) => ({
                                        ...prevData,
                                        warrenty_duration: e.target.value || null,
                                        warrenty_expiration_date: moment(lifetime?.warrenty_start_date).add(e.target.value, 'years').format('YYYY-MM-DD')
                                    }));
                                }}
                                InputLabelProps={{
                                    shrink: asset?.warrenty_duration !== null && asset?.warrenty_duration !== '',
                                }}
                                inputProps={{
                                    style: { padding: '10px' },
                                }}
                                variant="outlined"
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button size="small" variant="contained" color="secondary"
                        onClick={() => {
                            setAnotherOpen(false);
                            setLifetimeErrors({});
                            setLifetime({
                                acquisiton_date: null,
                                useful_life: 0,
                                end_of_userful_life_date: null,
                                depreciation: null,
                                warrenty_start_date: null,
                                warrenty_expiration_date: null,
                                warrenty_duration: null
                            });
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        disabled={!lifetimeValid || dataLoading}
                        onClick={async () => {
                            const errors = validateLifetime(lifetime);
                            if (Object.keys(errors).length > 0) { setLifetimeErrors(errors); return; }
                            try {
                                setDataLoading(true);
                                const response = await apiRequest('put', `/project-item/${itemData?.item_id}`, {
                                    ...itemData,
                                    acquisiton_date: lifetime?.acquisiton_date !== 'Invalid date' ? moment(lifetime?.acquisiton_date).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    useful_life: lifetime?.useful_life ? Number(lifetime?.useful_life) : 0,
                                    end_of_userful_life_date: lifetime?.end_of_userful_life_date !== 'Invalid date' ? moment(lifetime?.end_of_userful_life_date).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    depreciation: lifetime?.depreciation,
                                    warrenty_start_date: lifetime?.warrenty_start_date !== 'Invalid date' ? moment(lifetime?.warrenty_start_date).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    warrenty_expiration_date: lifetime?.warrenty_expiration_date !== 'Invalid date' ? moment(lifetime?.warrenty_expiration_date).format('YYYY-MM-DDThh:mm:ssZ') : null,
                                    warrenty_duration: lifetime?.warrenty_duration ? lifetime?.warrenty_duration?.toString() : ''
                                });
                                if (response.data) {
                                    setAnotherOpen(false);
                                    setLifetimeErrors({});
                                    setLifetime({
                                        acquisiton_date: null,
                                        useful_life: 0,
                                        end_of_userful_life_date: null,
                                        depreciation: null,
                                        warrenty_start_date: null,
                                        warrenty_expiration_date: null,
                                        warrenty_duration: null
                                    });
                                    getInitialData();
                                    setDataLoading(false);
                                    showNotification(response.data.message, 'success');
                                }
                            } catch (error) {
                                setDataLoading(false);
                                showNotification(error?.response?.data.error || error.message, 'error');
                            }
                        }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={1} mb={1}>
                <Typography varaint="body1" style={{ fontWeight: 'bold' }}>Asset</Typography>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ textTransform: 'capitalize' }}
                    onClick={() => { setOpen(true); }}
                >
                    Add
                </Button>
            </Box>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Serial No:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.serial_no || '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Bio-Med Tag:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.bio_med_tag || '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Condition:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.condition ? Condtions.find((a) => a.value === itemData?.condition)?.name : '--'}</DemoTypo>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box display="flex" alignItems="center" gap={1} mt={1}>
                        <DemoTypography variant="body2">Asset Tag:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.asset_tag || '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Other Tag:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.other_tag || '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Condition Notes:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.condition_notes || '--'}</DemoTypo>
                    </Box>
                </Grid>
            </Grid>
            <Divider />
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={1} mb={1}>
                <Typography varaint="body1" style={{ fontWeight: 'bold' }}>Costing/Lifetime</Typography>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    style={{ textTransform: 'capitalize' }}
                    onClick={() => { setAnotherOpen(true); }}
                >
                    Add
                </Button>
            </Box>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Acquisiton Date:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.acquisiton_date ? moment(itemData?.acquisiton_date).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">End of useful Life Date:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.end_of_userful_life_date ? moment(itemData?.end_of_userful_life_date).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Warrenty start Date:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.warrenty_start_date ? moment(itemData?.warrenty_start_date).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Warrenty End Date:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.warrenty_expiration_date ? moment(itemData?.warrenty_expiration_date).format('YYYY-MM-DD') : '--'}</DemoTypo>
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box display="flex" alignItems="center" gap={1} mt={1}>
                        <DemoTypography variant="body2">Useful Life (years):</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.useful_life || '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Depreciation (%):</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.depreciation || '--'}</DemoTypo>
                    </Box>
                    <Box display="flex" alignItems="center" gap={1}>
                        <DemoTypography variant="body2">Warrenty Duration:</DemoTypography>
                        <DemoTypo variant="body2">{itemData?.warrenty_duration || '--'}</DemoTypo>
                    </Box>
                </Grid>
            </Grid>
            <Box display="flex" justifyContent="space-between" alignItems="center" mt={1} mb={1}>
                <Typography varaint="body1" style={{ fontWeight: 'bold' }}>Depreciation Calculation</Typography>
            </Box>
            <Grid container>
                <Grid item xs={12} md={12}>
                    <FormControl>
                        <RadioGroup
                            row
                            aria-labelledby="demo-radio-buttons-group-label"
                            value={type}
                            name="radio-buttons-group"
                            onChange={(e) => { setType(e.target.value); }}
                        >
                            <FormControlLabel value="wdv" control={<Radio />} label="% Written Down Value (WDV)" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }} />
                            <FormControlLabel value="slm" control={<Radio />} label="Straight Line Method (SLM)" sx={{ '& .MuiFormControlLabel-label': { fontSize: '14px' } }} />
                        </RadioGroup>
                    </FormControl>
                </Grid>

                {type !== null && (
                    <Grid item xs={12} md={12}>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypography variant="body2">{type === 'slm' ? 'Salvage Value' : 'Scrap Value'}</DemoTypography>
                            <TextField
                                type="number"
                                value={scrapAmount}
                                variant="standard"
                                placeholder={type === 'slm' ? 'Salvage Value' : 'Scrap Value'}
                                onChange={(e) => { setAmount(e.target.value) }}
                            />
                            <Tooltip
                                title={
                                    (type === 'slm' && !slmCanShow)
                                        ? `Fill in Costing/Lifetime first: ${slmMissingFields.join(', ')}`
                                    : (type === 'wdv' && !wdvCanShow)
                                        ? `Fill in Costing/Lifetime first: ${wdvMissingFields.join(', ')}`
                                    : ''
                                }
                                arrow
                            >
                                <span>
                            <Button
                                size="small"
                                variant="contained"
                                color="primary"
                                disabled={
                                    dataLoading ||
                                    (type === 'slm' && !slmCanShow) ||
                                    (type === 'wdv' && !wdvCanShow)
                                }
                                onClick={async () => {
                                    try {
                                        setDataLoading(true);
                                        const updateData = { ...itemData };
                                        if (type === 'slm') updateData.salvage_amount = scrapAmount;
                                        if (type === 'wdv') updateData.scrape_amount = scrapAmount;
                                        const response = await apiRequest('put', `/project-item/${itemData?.item_id}`, updateData);
                                        if (response.data) {
                                            setOpen(false);
                                            getInitialData();
                                            setDataLoading(false);
                                            showNotification(response.data.message, 'success');
                                        }
                                    } catch (error) {
                                        setDataLoading(false);
                                        showNotification(error?.response?.data.error || error.message, 'error');
                                    }
                                }}
                            >
                                Save
                            </Button>
                                </span>
                            </Tooltip>
                        </Box>
                        <Box display="flex" alignItems="center" gap={1}>
                            <DemoTypography variant="body2">Cost</DemoTypography>
                            <DemoTypo variant="body2">{itemTotal || '--'}</DemoTypo>
                        </Box>
                    </Grid>
                )}

                {/* ── SLM: missing-field warning ── */}
                {type === 'slm' && !slmCanShow && slmMissingFields.length > 0 && (
                    <Grid item xs={12} md={12} mt={1}>
                        <Alert severity="warning" variant="outlined">
                            <Typography variant="body2" fontWeight="bold" mb={0.5}>
                                To generate the SLM depreciation schedule, please fill in the following fields in the <strong>Costing/Lifetime</strong> section above:
                            </Typography>
                            <ul style={{ margin: '4px 0 0 0', paddingLeft: 20 }}>
                                {slmMissingFields.map((field) => (
                                    <li key={field}>
                                        <Typography variant="body2">{field}</Typography>
                                    </li>
                                ))}
                            </ul>
                        </Alert>
                    </Grid>
                )}

                {/* ── WDV: missing-field warning ── */}
                {type === 'wdv' && !wdvCanShow && wdvMissingFields.length > 0 && (
                    <Grid item xs={12} md={12} mt={1}>
                        <Alert severity="warning" variant="outlined">
                            <Typography variant="body2" fontWeight="bold" mb={0.5}>
                                To generate the WDV depreciation schedule, please fill in the following fields in the <strong>Costing/Lifetime</strong> section above:
                            </Typography>
                            <ul style={{ margin: '4px 0 0 0', paddingLeft: 20 }}>
                                {wdvMissingFields.map((field) => (
                                    <li key={field}>
                                        <Typography variant="body2">{field}</Typography>
                                    </li>
                                ))}
                            </ul>
                        </Alert>
                    </Grid>
                )}

                {slmCanShow && (
                    (() => {
                        const years = generateYearRange(
                            itemData.acquisiton_date,
                            itemData.end_of_userful_life_date
                        );
                        return (
                            <>
                                <Tooltip title="Export to Excel">
                                    <IconButton
                                        style={{ float: 'right' }}
                                        onClick={async () => {
                                            const metanHeaders = ['Numeric ID','Description','Model','Manufacturer','Acquisition Date','End of Useful Life Date','Useful Life (years)','Depreciation (%)','Warranty Duration','Warranty Start Date','Warranty End Date','Salvage Value','Cost'];
                                            const metadata = {
                                                'Numeric ID': itemData?.product?.is_customer_product ? `C-${itemData?.product?.alternate_id}` : itemData?.product?.["numaric_sku"] ? `${itemData?.product?.category?.["sku_no"] || ''}${itemData?.product?.sub_category?.["sku_no"] || ''}-${String(itemData?.product?.["numaric_sku"]).padStart(3, '0')}` : `${itemData?.product?.category?.["sku_no"] || ''}${itemData?.product?.sub_category?.["sku_no"] || ''}-${String(0).padStart(3, '0')}`,
                                                'Description': `${itemData?.product?.category?.name || ''}, ${itemData?.product?.["sub_category"]?.name || ''}`,
                                                'Model': itemData?.product_data?.model !== undefined ? itemData?.product_data?.model : itemData?.product?.model !== 'null' ? itemData?.product?.model !== null ? itemData?.product?.model : 'UnSpecified' : 'UnSpecified',
                                                'Manufacturer': `${handleUndefined(itemData?.manufacturer?.name, itemData?.product?.manufacturer?.name) || '--'}`,
                                                'Acquisition Date': itemData?.acquisiton_date ? moment(itemData?.acquisiton_date).format('YYYY-MM-DD') : '--',
                                                'End of Useful Life Date': itemData?.end_of_userful_life_date ? moment(itemData?.end_of_userful_life_date).format('YYYY-MM-DD') : '--',
                                                'Useful Life (years)': itemData?.useful_life || '--',
                                                'Depreciation (%)': itemData?.depreciation || '--',
                                                'Warranty Duration': itemData?.warrenty_duration || '--',
                                                'Warranty Start Date': itemData?.warrenty_start_date ? moment(itemData?.warrenty_start_date).format('YYYY-MM-DD') : '--',
                                                'Warranty End Date': itemData?.warrenty_expiration_date ? moment(itemData?.warrenty_expiration_date).format('YYYY-MM-DD') : '--',
                                                'Salvage Value': `${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${scrapAmount}` || '--',
                                                'Cost': `${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${itemTotal || '--'}`
                                            };
                                            const metadataRow = Object.values(metadata);
                                            const depreciationHeaders = ['Years','Depreciation','Accumulated Dep','Net Carrying Value/Book Value'];
                                            const depreciationData = years.map((year, index) => [
                                                year,
                                                `${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${parseFloat((itemTotal - scrapAmount) / itemData.useful_life).toFixed(2)}`,
                                                `${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${parseFloat(((itemTotal - scrapAmount) / itemData.useful_life) * (index + 1)).toFixed(2)}`,
                                                `${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${parseFloat(itemTotal - ((itemTotal - scrapAmount) / itemData.useful_life) * (index + 1)).toFixed(2)}`
                                            ]);
                                            const combinedData = [metanHeaders, metadataRow, [], depreciationHeaders, ...depreciationData];
                                            const worksheet = XLSX.utils.aoa_to_sheet(combinedData);
                                            const maxColLengths = [];
                                            combinedData.forEach(row => { row.forEach((cell, colIndex) => { const cellLength = cell ? cell.toString().length : 0; if (!maxColLengths[colIndex] || cellLength > maxColLengths[colIndex]) maxColLengths[colIndex] = cellLength; }); });
                                            worksheet['!cols'] = maxColLengths.map(width => ({ width: Math.min(width + 4, 50) }));
                                            const workbook = XLSX.utils.book_new();
                                            XLSX.utils.book_append_sheet(workbook, worksheet, "Depreciation Schedule");
                                            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
                                            const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
                                            saveAs(fileData, "SLMDepreciation.xlsx");
                                        }}
                                    >
                                        <CloudDownloadOutlinedIcon color="primary" />
                                    </IconButton>
                                </Tooltip>
                                <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                                    <TableContainer>
                                        <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                                            <TableHead>
                                                <TableRow>
                                                    <Cell style={{ width: '10%' }}>Years</Cell>
                                                    <Cell style={{ width: '30%' }}>Depreciation</Cell>
                                                    <Cell style={{ width: '30%' }}>Accumulated Dep</Cell>
                                                    <Cell style={{ width: '30%' }}>Net Carrying Value/Book Value</Cell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {years.map((year, index) => (
                                                    <TableRow key={index}>
                                                        <Cell>{year}</Cell>
                                                        <Cell>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${parseFloat((itemTotal - scrapAmount) / itemData.useful_life).toFixed(2)}`}</Cell>
                                                        <Cell>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${parseFloat(((itemTotal - scrapAmount) / itemData.useful_life) * (index + 1)).toFixed(2)}`}</Cell>
                                                        <Cell>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${parseFloat(itemTotal - ((itemTotal - scrapAmount) / itemData.useful_life) * (index + 1)).toFixed(2)}`}</Cell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </>
                        );
                    })()
                )}

                {wdvCanShow && (
                    (() => {
                        const generateYearsUntilScrap = (startDate, maxYears = 50) => {
                            const years = [];
                            const startYear = new Date(startDate).getFullYear();
                            for (let i = 0; i < maxYears; i++) years.push((startYear + i).toString());
                            return years;
                        };
                        const years = generateYearsUntilScrap(itemData.acquisiton_date, 50);
                        const cost = parseFloat(itemTotal);
                        const depreciationRate = parseFloat(itemData.depreciation) / 100;
                        const scrapValue = parseFloat(scrapAmount || 0);
                        let bookValue = cost;
                        let accumulatedDepreciation = 0;
                        const depreciationSchedule = [];
                        for (let i = 0; i < years.length; i++) {
                            if (bookValue <= scrapValue) break;
                            let yearDepreciation = bookValue * depreciationRate;
                            if (i === 0) yearDepreciation = cost * depreciationRate;
                            if (bookValue - yearDepreciation < scrapValue) yearDepreciation = bookValue - scrapValue;
                            if (yearDepreciation <= 0) break;
                            accumulatedDepreciation += yearDepreciation;
                            bookValue = cost - accumulatedDepreciation;
                            depreciationSchedule.push({ year: years[i], depreciation: yearDepreciation.toFixed(2), accumulatedDep: accumulatedDepreciation.toFixed(2), bookValue: bookValue.toFixed(2) });
                        }
                        return (
                            <>
                                <Tooltip title="Export to Excel">
                                    <IconButton
                                        style={{ float: 'right' }}
                                        onClick={async () => {
                                            const formattedData = depreciationSchedule.map((item) => ({
                                                'Years': item.year,
                                                'Depreciation': `${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${item.depreciation}`,
                                                'Accumulated Dep': `${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${item.accumulatedDep}`,
                                                'Net Carrying Value/Book Value': `${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${item.bookValue}`,
                                            }));
                                            const metanHeaders = ['Numeric ID','Description','Model','Manufacturer','Acquisition Date','End of Useful Life Date','Useful Life (years)','Depreciation (%)','Warranty Duration','Warranty Start Date','Warranty End Date','Salvage Value','Cost'];
                                            const metadata = {
                                                'Numeric ID': itemData?.product?.is_customer_product ? `C-${itemData?.product?.alternate_id}` : itemData?.product?.["numaric_sku"] ? `${itemData?.product?.category?.["sku_no"] || ''}${itemData?.product?.sub_category?.["sku_no"] || ''}-${String(itemData?.product?.["numaric_sku"]).padStart(3, '0')}` : `${itemData?.product?.category?.["sku_no"] || ''}${itemData?.product?.sub_category?.["sku_no"] || ''}-${String(0).padStart(3, '0')}`,
                                                'Description': `${itemData?.product?.category?.name || ''}, ${itemData?.product?.["sub_category"]?.name || ''}`,
                                                'Model': itemData?.product_data?.model !== undefined ? itemData?.product_data?.model : itemData?.product?.model !== 'null' ? itemData?.product?.model !== null ? itemData?.product?.model : 'UnSpecified' : 'UnSpecified',
                                                'Manufacturer': `${handleUndefined(itemData?.manufacturer?.name, itemData?.product?.manufacturer?.name) || '--'}`,
                                                'Acquisition Date': itemData?.acquisiton_date ? moment(itemData?.acquisiton_date).format('YYYY-MM-DD') : '--',
                                                'End of Useful Life Date': itemData?.end_of_userful_life_date ? moment(itemData?.end_of_userful_life_date).format('YYYY-MM-DD') : '--',
                                                'Useful Life (years)': itemData?.useful_life || '--',
                                                'Depreciation (%)': itemData?.depreciation || '--',
                                                'Warranty Duration': itemData?.warrenty_duration || '--',
                                                'Warranty Start Date': itemData?.warrenty_start_date ? moment(itemData?.warrenty_start_date).format('YYYY-MM-DD') : '--',
                                                'Warranty End Date': itemData?.warrenty_expiration_date ? moment(itemData?.warrenty_expiration_date).format('YYYY-MM-DD') : '--',
                                                'Salvage Value': `${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${scrapValue}` || '--',
                                                'Cost': `${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${cost || '--'}`
                                            };
                                            const metadataRow = Object.values(metadata);
                                            const depreciationHeaders = ['Years','Depreciation','Accumulated Dep','Net Carrying Value/Book Value'];
                                            const depreciationData = formattedData.map(item => [item.Years, item.Depreciation, item['Accumulated Dep'], item['Net Carrying Value/Book Value']]);
                                            const combinedData = [metanHeaders, metadataRow, [], depreciationHeaders, ...depreciationData];
                                            const worksheet = XLSX.utils.aoa_to_sheet(combinedData);
                                            const maxColLengths = [];
                                            combinedData.forEach(row => { row.forEach((cell, colIndex) => { const cellLength = cell ? cell.toString().length : 0; if (!maxColLengths[colIndex] || cellLength > maxColLengths[colIndex]) maxColLengths[colIndex] = cellLength; }); });
                                            worksheet['!cols'] = maxColLengths.map(width => ({ width: Math.max(Math.min(width + 4, 50), 10) }));
                                            const workbook = XLSX.utils.book_new();
                                            XLSX.utils.book_append_sheet(workbook, worksheet, "Depreciation Schedule");
                                            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
                                            const fileData = new Blob([excelBuffer], { type: "application/octet-stream" });
                                            saveAs(fileData, "WDVDepreciation.xlsx");
                                        }}
                                    >
                                        <CloudDownloadOutlinedIcon color="primary" />
                                    </IconButton>
                                </Tooltip>
                                <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                                    <TableContainer>
                                        <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                                            <TableHead>
                                                <TableRow>
                                                    <Cell style={{ width: '10%' }}>Years</Cell>
                                                    <Cell style={{ width: '30%' }}>Depreciation</Cell>
                                                    <Cell style={{ width: '30%' }}>Accumulated Dep</Cell>
                                                    <Cell style={{ width: '30%' }}>Net Carrying Value/Book Value</Cell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {depreciationSchedule.map((row, index) => (
                                                    <TableRow key={index}>
                                                        <Cell>{row.year}</Cell>
                                                        <Cell>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${row.depreciation}`}</Cell>
                                                        <Cell>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${row.accumulatedDep}`}</Cell>
                                                        <Cell>{`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${row.bookValue}`}</Cell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Box>
                            </>
                        );
                    })()
                )}
            </Grid>
        </>
    )
}

export default AssetManagement;